import { FC, useEffect } from "react";
import styles from "./styles.module.css";
import { useSearchParams } from "react-router-dom";

interface Props {
  hasNextPage: boolean;
}

const Pagination: FC<Props> = ({ hasNextPage }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get("page") || "1");

  const setCurrentPage = (page: number) => {
    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      page: page.toString(),
    });
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Формируем массив кружков: предыдущая, текущая, следующая 
  const pages = [];
  if (currentPage > 1) pages.push(currentPage - 1);
  pages.push(currentPage);
  if (hasNextPage) pages.push(currentPage + 1);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [currentPage]);

  return (
    <div className={styles.pagination}>
      {currentPage > 3 && (
        <>
          <button
            className={styles.pagination_btn}
            onClick={() => handlePageChange(1)}
          >
            1
          </button>
          <span className={styles.ellipsis}>...</span>
        </>
      )}

      {pages.map((page) => (
        <button
          key={page}
          className={styles.pagination_btn}
          onClick={() => handlePageChange(page)}
          disabled={page === currentPage} // текущий кружок
        >
          {page}
        </button>
      ))}

      {hasNextPage && (
        <button
          className={styles.further_btn}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      )}
    </div>
  );
};

export default Pagination;